import axios from 'axios';

import { API_BASE_URL } from '@config';

// SET
export const SET_ALL_CLUSTER = 'SET_ALL_CLUSTER';
export const setAllCluster = d => ({
	type: SET_ALL_CLUSTER,
	payload: d
});

export const SET_SELECTED_CLUSTER = 'SET_SELECTED_CLUSTER';
export const setSelectedCluster = d => ({
	type: SET_SELECTED_CLUSTER,
	payload: d
});


// * ////////////// GET ////////////// * //
export const getAllCluster = () => dispatch => {
	const request = axios.get(`${API_BASE_URL}/api/clusters/names`);

	return request
		.then(response => {
			dispatch(setAllCluster({data: response.data}));
		});
};

export const getSelectedCluster = custer => dispatch => {
	dispatch(setSelectedCluster({data: custer}));
}


